import React from "react";
import styled from "styled-components";
import BWModels from "@benjamin-west-rpm2/benjamin-west-models";

import { FormGrid, FormikForm } from "../../../../../forms";
import { ActionButtons } from "../../../../../forms/ActionButtons";
import { inputs } from "../../../../../inputs/inputConfigs";
import { areaTypeDataComponentId } from "../AreaTypeContainer";
import CheckboxWithError from "../../../../../inputs/CheckboxWithError";

const Wrapper = styled.div``;

const fields = {
  groups: [
    {
      items: [
        {
          input: inputs.name,
          grid: { xs: 12 },
        },
        {
          input: {
            name: "isMultiple",
            InputComponent: CheckboxWithError,
            label: "Multiple",
            checkValues: {
              check: true,
              uncheck: false,
            },
          },
          grid: { xs: 12 },
        },
      ],
    },
  ],
};

export const CreateAreaType = ({ handleCreateAreaType, closeModalDialog }) => {
  return (
    <FormikForm
      initialValues={{ name: "", isMultiple: false }}
      onSubmit={handleCreateAreaType}
      validationSchema={BWModels.loadSchema("AreaType")}
    >
      {({ handleSubmit, values, ...formikProps }) => (
        <Wrapper>
          <FormGrid fields={fields} {...formikProps} />
          <ActionButtons
            onSend={handleSubmit}
            onCancel={closeModalDialog}
            sendButtonText="Create"
            listeners={[areaTypeDataComponentId]}
            isModal
          />
        </Wrapper>
      )}
    </FormikForm>
  );
};
